import { render, staticRenderFns } from "./InitialsList.vue?vue&type=template&id=ef747318&scoped=true&"
import script from "./InitialsList.vue?vue&type=script&lang=js&"
export * from "./InitialsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef747318",
  null
  
)

export default component.exports